<!--
 * @Description: 登录
 * @Author: 山淑兰
 * @Date: 2019-10-11 15:44:40
 * @LastEditTime: 2020-07-10 09:33:41
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="page">
		<iframe :src="expertUrl" width="100%" :class="eHeight?'has':'no'" border="0" frameborder="no"></iframe>
		<eFooter :height="eHeight"  style="position: fixed;"></eFooter>
	</div>
</template>
<script>
	import eFooter from '@components/eFooter.vue'
	import Cookies from 'js-cookie'
	import publicSignup from '../../lib/signUp.js'
	export default {
		name: 'login',
		components: {
			eFooter
		},
		data() {
			return {
				publicTools: {}, //通用publicSignup
				meetingInfo: {}, //会议基本数据
				expertUrl: '',
			}
		},

		created() {
			this.data = this.$route.query
			if( Cookies.get('wqExpertToken') || localStorage.getItem('wqExpertToken') ){
				this.checkLoginStatus()
				this.init()
				this.getmeetingInfo()
			} else {
				let toUrl = encodeURIComponent(window.location.href)
				this.$router.push({
					path: '/elogin',
					query: { ...this.data, toUrl }
				})
			}
		},
		mounted() {
			
		},
		methods: {
			//获取会议基本信息
			async getmeetingInfo() {
				let opt = {
					m: this.data.m,
					ch: this.$route.query.ch,
				}
				this.meetingInfo = await this.publicTools.init(opt, this)
			},
			async checkLoginStatus() {
				let _params = {
					m: this.data.m,
				}
				let _Res = await this.$http.checkExpert(_params)
			},
			async init() {
				let _params = {
					m: this.data.m,
				}
				let Res = await this.$http.initExpertPage(_params)
				if (Res.Code === 1000) {
					this.expertUrl = Res.ExpertUrl
				}else {
					this.$notify({
						message: Res.Msg,
						type: 'danger',
					})
				}
			},
		},
	}
</script>
<style scoped lang="scss">
	#page {
		width: 100%;
		height: 100vh;
	}
</style>
<style type="text/css">
	body,
	#app {
		background: linear-gradient(135deg, #eef2f7 0%, #f5f7fc 40%, #e8edf5 100%);
	}
	.has{
		height: calc(100% - 45px);
	}
	.no{
		height: 100%;
	}
</style>
